import { render, staticRenderFns } from "./SystemVmsTab.vue?vue&type=template&id=2f5a3fa6&scoped=true&"
import script from "./SystemVmsTab.vue?vue&type=script&lang=js&"
export * from "./SystemVmsTab.vue?vue&type=script&lang=js&"
import style0 from "./SystemVmsTab.vue?vue&type=style&index=0&id=2f5a3fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a3fa6",
  null
  
)

export default component.exports